import { defineCustomElement } from '../chunks/vidstack-SU9Igk1e.js';
import { MediaPlayerElement, MediaProviderElement } from '../chunks/vidstack-B8_86cXX.js';
import '../chunks/vidstack-DaIXMR2G.js';
import '../chunks/vidstack-Do9HXrsy.js';
import '../chunks/vidstack-BBt-iqE1.js';
import '../chunks/vidstack-BmEuXuTf.js';
import '../chunks/vidstack-BWcgQXKG.js';
import '../chunks/vidstack-DO-w-l5s.js';
import '../chunks/vidstack-C07IaTje.js';
import '../chunks/vidstack-D5EzK014.js';
import '../chunks/vidstack-B01xzxC4.js';
import '../chunks/vidstack-C9vIqaYT.js';
import '../chunks/vidstack-CDhZT2hV.js';
import '@floating-ui/dom';
import '../chunks/vidstack-Dihypf8P.js';
import '../chunks/vidstack-Vzz_d3Ad.js';

defineCustomElement(MediaPlayerElement);
defineCustomElement(MediaProviderElement);
